import React from "react";
import Grid from "@material-ui/core/Grid";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { makeStyles } from "@material-ui/core/styles";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import PropTypes from "prop-types";
const useStyles = makeStyles(theme => ({
  ...dashboardStyle,
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: "#999 !important",
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "1.42857 !important",
    letterSpacing: "unset !important"
  },
  rootB: {
    "&:before": {
      borderBottomColor: "lightgrey !important"
    },
    "&:after": {
      borderBottomColor: "lightgrey !important"
    }
  },
  container: {
    textAlign: "center"
  },
  content: {
    display: "inline-flex",
    padding: "10px",
    alignItems: "center"
  },
  paddingBottomCard: {
    paddingBottom: "40px"
  },
  marginRight: {
    marginRight: "10px"
  },
  marginBottom: {
    marginBottom: "50px"
  },
  formControl: {
    marginTop: theme.spacing(3.5),
    minWidth: "100%"
  },
  formControlMid: {
    marginTop: theme.spacing(3.5),
    minWidth: "50%"
  },
  formControlSeven: {
    marginTop: theme.spacing(3.5),
    minWidth: "70%"
  },
  checkControl: {
    marginTop: theme.spacing(5)
  },
  formControlDate: {
    marginTop: theme.spacing(1.5),
    minWidth: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  showSpinner: {
    float: "right",
    display: "block"
  },
  hideSpinner: {
    display: "none"
  },
  disabledSelect: {
    opacity: "0.5 !important"
  },
  enableSelect: {
    opacity: "1 !important"
  }
}));

const CardForms = ({ children, title }) => {
  const classes = useStyles();
  return (
    <Grid className={classes.marginBottom}>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitle}> {title} </h4>{" "}
          </CardHeader>{" "}
          <CardBody>{children}</CardBody>
        </Card>
      </GridItem>
    </Grid>
  );
};

CardForms.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
};
export default CardForms;
